export default __webpack_public_path__ + "efbff88cd80c83711e73bf7301b1e1a8.png";